export const accordionBlock = () => {
  const accordions = document.querySelectorAll('.accordion')

  accordions.forEach((tab) => {
    tab.addEventListener('click', () => {
      if (tab.classList.contains('show')) {
        tab.classList.remove('show')
      } else {
        tab.classList.add('show')
      }
    })
  })
}
